export default __webpack_public_path__ + "static/media/Mask Group 7.b73ddfa6.png";